module.exports = __webpack_public_path__ + "img/13.408bf67a.jpg";